import React, { Component } from "react";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { WhiteSpace, Flex } from "antd-mobile";
import Article from "../../knowledge/components/article";
import Comment from "../../knowledge/components/comment";
import syncGetQRCode from "../../../common/QRCode";

import { getPatientIdFromUrl } from "../../../utils";
import BuriedPoint from "../../../utils/log";

class knowledgeShare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qrcodeUrl: null,
    };
  }

  componentDidMount() {
    const userId = getPatientIdFromUrl(this.props);
    BuriedPoint.saLog("PAGE_INIT_KNOWLEDGE_SHARE", {
      id: userId,
      payload: {},
    });
  }

  componentWillMount = () => {
    const setState = this.setState.bind(this);
    const userId = getPatientIdFromUrl(this.props);
    const postData = {
      userId,
      title: "涨知识分享",
      description: "个人邀请二维码",
      marketingChannel: "WECHAT_REFERRAL",
      location: "微信公众号",
      action: "INVITE_PATIENT",
    };
    syncGetQRCode(postData).then(function (url) {
      setState({ qrcodeUrl: url });
    });
  };

  render() {
    const comments = get(this.props, "blogs.blogs[0].comments");
    const hideComment = isEmpty(comments);
    return (
      <div
        style={{
          background: "White",
          position: "relative",
          paddingBottom: 80,
        }}
      >
        <Article isShare={true} {...this.props} />
        {/* <div
          style={{
            backgroundColor: 'rgba(248,247,248,1)',
            margin: '16px',
            height: '140px',
          }}
        >
          <div
            style={{
              paddingTop: '15px',
              paddingLeft: '15px',
              paddingRight: '15px',
              display: 'flex',
            }}
          >
            <div
              style={{
                float: 'left',
                flex: '1',
              }}
            >
              <img width="110px" src={this.state.qrcodeUrl} />
            </div>
            <div
              style={{
                float: 'left',
                marginLeft: '10px',
                flex: '1',
              }}
            >
              <div
                style={{
                  color: '#584F62',
                  fontSize: '15px',
                  lineHeight: '30px',
                }}
              >
                共同照护
                <br />
                糖尿病诊疗新模式
              </div>
              <div
                style={{
                  color: '#584F62',
                  fontSize: '12px',
                  marginTop: '15px',
                }}
              >
                长按二维码预约初诊
              </div>
            </div>
          </div>
        </div> */}
        {hideComment || <Comment isShare={true} {...this.props} />}
        <div
          style={{
            background: "#24C6AE",
            width: "100%",
            height: 80,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            position: "fixed",
            bottom: 0,
            zIndex: 99,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              paddingLeft: 10,
              paddingRight: 10,
            }}
          >
            <div
              style={{
                color: "#FFFFFF",
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              查看完整内容请下载『共同照护APP』
            </div>
            <div
              style={{
                height: 17,
                paddingTop: 8,
                color: "#FFFFFF",
                fontSize: "12px",
                fontWeight: 400,
              }}
            >
              共同照护APP：照护长相伴，健康更简单
            </div>
          </div>
          <button
            style={{
              backgroundColor: "rgba(255,255,255,1)",
              width: 70,
              height: 34,
              borderRadius: 4,
              color: "#24C6AE",
              fontSize: "16px",
              fontWeight: 600,
              textAlign: "center",
            }}
            type="button"
            onClick={() => {
              window.location.href =
                "https://a.app.qq.com/o/simple.jsp?pkgname=com.ihealth.HuTang&fromcase=40002#fromopen&opened";
            }}
          >
            下载
          </button>
        </div>
      </div>
    );
  }
}
export default knowledgeShare;



// WEBPACK FOOTER //
// ./src/modules/knowledgeShare/components/index.js